var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLoginBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1019 800",
    style: {
      enableBackground: "new 0 0 1019 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01393F;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0CB8C2;fill-opacity:0.69;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#0CB8C2;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#42DB89;fill-opacity:0.69;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#42DB89;fill-opacity:0.35;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-351.7,49.4l0,750.6h1899.5L-351.7,49.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,487.5l252.9,143.9L37.5,775.4l-252.9-143.9L37.5,487.5z M37.5,543.2l155.1,88.3L37.5,719.8 c-35.2-20.1-102.6-58.4-155.2-88.3L37.5,543.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.5,390.2l252.9,143.9L37.5,678l-252.9-143.9L37.5,390.2z M37.5,445.8l155.1,88.3c0,0-106.4,60.6-155.1,88.3 l-155.2-88.3L37.5,445.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1028.6-92.8l259.3,142.2l-259.3,142.2L769.2,49.4L1028.6-92.8z M1028.6-37.8l159.1,87.2l-159.1,87.2 c-36.1-19.8-105.2-57.7-159.1-87.2L1028.6-37.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1028.6,6.4l259.3,142.2l-259.3,142.2L769.2,148.6L1028.6,6.4z M1028.6,61.4l159.1,87.2 c0,0-109.1,59.8-159.1,87.2c-36.1-19.8-105.2-57.7-159.1-87.2L1028.6,61.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLoginBg);
export default __webpack_public_path__ + "static/media/new-login-bg.68f54fc9642430ec60ca59674d279e53.svg";
export { ForwardRef as ReactComponent };